import React from 'react';
import { Textarea } from '@mantine/core';
import { BaseFieldProps } from './types';

export function TextField<T extends Record<string, unknown>>({
  entityMetadata,
  fieldLabel,
  disabled,
  form,
  formFieldName,
  variant,
  fieldName,
  onChange,
}: BaseFieldProps<T>) {
  const inputProps = form.getInputProps(formFieldName);

  return (
    <Textarea
      id={formFieldName}
      required={!entityMetadata.isOptional}
      resize="vertical"
      key={form.key(formFieldName)}
      label={fieldLabel}
      labelProps={{ variant: 'light' }}
      placeholder=""
      disabled={disabled}
      minRows={3}
      autosize
      {...inputProps}
      variant={variant}
      onChange={value => onChange(value, fieldName)}
    />
  );
}
